<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import moment from "moment";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue";
import StrRiskDegerlendirmeKriterTablosu from "@/models/StrRiskDegerlendirmeKriterTablosu";

export default {
  mixins: [Api, Sabit,StrRiskDegerlendirmeKriterTablosu],
  page: {
    title: "Risk Degerlendirme Kriter Tablosu",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit
  },
  data() {
    return {
      title: this.$t("StrRiskDegerlendirmeKriterTablosu.Title"),
      items: [
        {
          text: this.$t("StrRiskDegerlendirmeKriterTablosu.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrRiskDegerlendirmeKriterTablosu.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrRiskDegerlendirmeKriterTablosu.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: ""
    };
  },

  methods: {
    Get() {
         
         let Filter="";
      this.ActionsFilterGet({ Service: "StrRiskDegerlendirmeKriterTablosu", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateTable(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.AddEdit @click="(DataUpdate = StrRiskDegerlendirmeKriterTablosuData), (AddEdit = 'Add')"><i class="mdi mdi-plus me-1"></i> {{ $t("StrRiskDegerlendirmeKriterTablosu.Page.YeniKayitEkle") }}</button>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("StrRiskDegerlendirmeKriterTablosu.Table.Baslangicdegeri") }}</th>
                      <th>{{ $t("StrRiskDegerlendirmeKriterTablosu.Table.Bitisdegeri") }}</th>
                      <th>{{ $t("StrRiskDegerlendirmeKriterTablosu.Table.Aralik") }}</th>
                      <th>{{ $t("StrRiskDegerlendirmeKriterTablosu.Table.Olasilik") }}</th>
                      <th>{{ $t("StrRiskDegerlendirmeKriterTablosu.Table.Etkistrateji") }}</th>
                      <th>{{ $t("StrRiskDegerlendirmeKriterTablosu.Table.Etkifaaliyetsurec") }}</th>
                      <th>{{ $t("StrRiskDegerlendirmeKriterTablosu.Table.Etkimali") }}</th>
                      <th>{{ $t("StrRiskDegerlendirmeKriterTablosu.Table.Etkimevzuatauyum") }}</th>
                      <th>{{ $t("StrRiskDegerlendirmeKriterTablosu.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody v-for="(Data, Index) in TableData" :key="Index">
                    <tr v-if="Data.Deleted == false">
                      <th scope="row">{{ Data.Baslangicdegeri }}</th>
                      <td>{{ Data.Bitisdegeri }}</td>
                      <td>{{ Data.Aralik }}</td>
                      <td>{{ Data.Olasilik }}</td>
                      <td>{{ Data.Etkistrateji }}</td>
                      <td>{{ Data.Etkifaaliyetsurec }}</td>
                      <td>{{ Data.Etkimali }}</td>
                      <td>{{ Data.Etkimevzuatauyum }}</td>
                      <td>
                        <div class="action-is w-100 d-flex justify-content-center align-items-center">
                          <i class="fas fa-pencil-alt" v-b-modal.AddEdit @click="(DataUpdate = Data), (AddEdit = 'Edit')"></i>
                          <i class="fas fa-trash-alt" @click="Delete('StrRiskDegerlendirmeKriterTablosu', Data.Id)"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
    </Layout>
  </Loader>
</template>
